export default __webpack_public_path__ + "static/media/element_59.a348eff4.jpg";